var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.056 2.4c-5.067 0-9.249 3.84-9.8 8.761h-2.01a.404.404 0 0 0-.31.666l2.966 3.491c.162.19.455.19.617 0l2.964-3.49a.404.404 0 0 0-.307-.667h-1.86c.54-3.792 3.801-6.721 7.74-6.721 4.77 0 8.558 4.291 7.705 9.216-.539 3.11-3.004 5.65-6.097 6.272-2.814.568-5.591-.385-7.428-2.43a.427.427 0 0 0-.588-.056l-.917.743a.437.437 0 0 0-.059.625c2.428 2.74 6.181 3.952 9.927 2.999 3.658-.93 6.494-4.015 7.16-7.732C23.874 7.843 19.089 2.4 13.056 2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.105 15.9-3.48-1.462a1.02 1.02 0 0 1-.625-.94V7.2h2.039v5.62l2.856 1.2-.79 1.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.449bd748890a12f00c27e0aded3db077.svg";
export { ForwardRef as ReactComponent };